import animationLogo from "lotties/logo.json";
export const logoOptions = {
  loop: true,
  autoplay: true,
  animationData: animationLogo,
  rendererSettings: {
    preserveAspectRatio: "xMidYMid slice",
  },
};
